import { Accordion, Grid } from "basis";
import { mapValueToLabel } from "library/utils";
import {
  primaryReasonOptions,
  secondaryReasonOptions,
} from "pages/HardshipApplication/options";
import { TextCell } from "pages/HardshipApplication/Review/TextCell";
import { useHardshipApplicationContext } from "../../hooks/useHardshipApplicationContext";

export const ReasonsForApplyingAccordion = () => {
  const { state } = useHardshipApplicationContext();
  const { reasonsForApplying } = state;

  if (!reasonsForApplying) {
    return null;
  }

  const { primaryReason, secondaryReason, startDate, situation } =
    reasonsForApplying;

  return (
    <Accordion>
      <Accordion.Item initiallyOpen>
        <Accordion.Item.Header>Your reasons for applying</Accordion.Item.Header>
        <Accordion.Item.Content>
          <Grid
            cols="8"
            colsGap-sm="4"
            rowsGap="8"
            testId="reasons-for-applying"
          >
            <Grid.Item colSpan="all" colSpan-sm="0-8" rowSpan-sm="0">
              <TextCell header="Main reason" testId="main-reason">
                {mapValueToLabel(primaryReason, primaryReasonOptions)}
              </TextCell>
            </Grid.Item>
            <Grid.Item colSpan="all" colSpan-sm="0-8" rowSpan-sm="1">
              <TextCell header="Other reason" testId="other-reason">
                {mapValueToLabel(secondaryReason, secondaryReasonOptions)}
              </TextCell>
            </Grid.Item>
            <Grid.Item colSpan="all" colSpan-sm="0-8" rowSpan-sm="2">
              <TextCell
                header="If your application is approved, when is the earliest you can start making payments?"
                testId="start-date"
              >
                {`${startDate.day}/${startDate.month}/${startDate.year}`}
              </TextCell>
            </Grid.Item>
            <Grid.Item colSpan="all" colSpan-sm="0-8" rowSpan-sm="3">
              <TextCell
                header="Anything else you’d like to tell us about your situation?"
                testId="situation"
              >
                {situation}
              </TextCell>
            </Grid.Item>
          </Grid>
        </Accordion.Item.Content>
      </Accordion.Item>
    </Accordion>
  );
};
